<div class="container my-4">
  <div class="topheadtitle">
    <h4>eCitation Vendors</h4>
  </div>

  <div class="saerch-section d-flex justify-content-between mb-2">
    <div class="row g-3 align-items-center">
      <div class="col-auto">
        <label for="inputPassword6" class="col-form-label">Filter</label>
      </div>
      <div class="col-auto">
        <input type="text" (keyup)="filterItems(searchQuery.value)" #searchQuery id="inputPassword6"
          class="form-control form-control-sm" placeholder="Search for any text" />
        </div>
      </div>

      @if (userType === 'S') {
        <div class="new-btn">
          <button class="btn btn-outline-secondary btn-sm" type="button" (click)="edit(contentda,'add',null)">
            New <i class="fa-sharp fa-solid fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      }
    </div>

    <main class="table-container w-100">
      <table class="table" summary="eCitation Vendors Results">
        <caption>eCitation list of vendors.</caption>

        <thead>
          <tr>
            <th scope="col">
              <button type="button" class="btn btn-link p-0 sort-header" aria-label="Sort by Vendor"
                (click)="onSort($event,'vendorName',true)">
                Vendor <i class="fa fa-sort" aria-hidden="true"></i>
              </button>
            </th>
            @if (userType === 'S') {
              <th scope="col">Edit</th>
            }
          </tr>
        </thead>

        <tbody>
          @for (item of getItems(); track item) {
            <tr>
              <td>{{item.vendorName}}</td>
              @if (userType === 'S') {
                <td>
                  <button type="button" class="icon-button" [attr.aria-label]="'Edit ' + item.vendorName"
                    (click)="edit(contentda,'edit',item.vendorId)">
                    <i class="fa-sharp fa-solid fa-pen-to-square" aria-hidden="true"></i>
                    <span class="visually-hidden">Edit {{ item.vendorName }}</span>
                  </button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>

      <div class="d-flex justify-content-between align-items-center">
        <div class="w-33">
          <span>{{listAllVendor.length}} items found, displaying {{getCurrentPageTotal()}} of
          {{listAllVendor.length}}</span>
        </div>

        <ngb-pagination [collectionSize]="listAllVendor.length" [(page)]="currentPage" [ellipses]="true" [maxSize]="10"
          (pageChange)="onPageChange(currentPage)" [pageSize]="10" [boundaryLinks]="true"
        aria-label="Vendors list pagination"></ngb-pagination>

        <div class="w-33"></div>
      </div>
    </main>
  </div>

  <ng-template class="modal-dialog modal-lg" #contentda let-modal>
    <div class="step-2" aria-modal="true" aria-labelledby="modal-basic-title">
      <div class="modal-header">
        <h4 style="font-size: 15px;" class="modal-title" id="modal-basic-title">{{mode =='add'?'Add New':'Edit'}} Vendor
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
      </div>

      <div class="modal-body">
        @if (alert) {
          <div class="alert alert-danger" role="alert">{{alert.message}}</div>
        }

        <div class="d-flex align-items-center justify-content-center">
          <div class="form">
            <form [formGroup]="editVendorForm" (ngSubmit)="updateVendor()">
              <div class="mb-2">
                <label for="vendorName" class="form-label">Vendor Name</label><span class="c-red">*</span>
                <input id="vendorName" formControlName="vendorName" type="text" class="form-control form-control-sm"
                  placeholder="Add a name" />
                  <app-control-message [control]="editVendorForm.get('vendorName')"
                  [message]="{required: 'Field is requried'}"></app-control-message>
                </div>

                <div class="mb-3" hidden>
                  <label for="newCourtNames" class="form-label">New Court Names</label>
              <select id="newCourtNames" formControlName="newCourtNames" multiple (change)="selectOption()
                " class="form-select form-select-sm">
                    @for (item of listAllCourt; track item) {
                      <option [value]="item.courtName">
                        {{item.courtName}}
                      </option>
                    }
                  </select>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger btn-sm me-2"
                  (click)="editVendorForm.reset();modal.close('Save click')">Cancel</button>
                  <button type="submit" [disabled]="!editVendorForm.dirty" class="btn btn-primary btn-sm">
                    {{mode=='add'?'Submit':'Update'}}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </ng-template>